module.exports = __webpack_public_path__ + "img/sb-android-screen.c88db389.png";